var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.395,
    height: 19.587,
    viewBox: "0 0 18.395 19.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "policy_image",
    transform: "translate(-1172.111 -615.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M1172.465,627.119l9.564-9.563a4.588,4.588,0,0,1,3.306-1.366h0a4.672,4.672,0,0,1,3.306,7.977l-9.564,9.564a3.554,3.554,0,1,1-5.026-5.026l8.77-8.77a2.131,2.131,0,0,1,1.519-.625h0a2.064,2.064,0,0,1,1.5.625,2.157,2.157,0,0,1,0,3.035l-6.376,6.376",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M1174.218,629.406l4.055,4.055a2.867,2.867,0,1,1-4.055-4.055Z",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyImage);
export default __webpack_public_path__ + "static/media/policy_image.99470288b81def6bd3f92caea7b39a6b.svg";
export { ForwardRef as ReactComponent };